// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__IdOd2","pageSize":"DataTableRemotePaging_pageSize__v5Ksb","selected":"DataTableRemotePaging_selected__rffYt"};